import { render } from "./log-list.vue?vue&type=template&id=2902ec51&ts=true"
import script from "./log-list.vue?vue&type=script&lang=ts"
export * from "./log-list.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__